import { vec3, vec4 } from "gl-matrix";

export const Vec4Colors = {
    White: vec4.fromValues(1.0, 1.0, 1.0, 1.0),
    Black: vec4.fromValues(0.0, 0.0, 0.0, 1.0),
    Red: vec4.fromValues(1.0, 0.0, 0.0, 1.0),
    DarkRed: vec4.fromValues(0.5, 0.0, 0.0, 1.0),
    Green: vec4.fromValues(0.0, 1.0, 0.0, 1.0),
    DarkGreen: vec4.fromValues(0.0, 0.5, 0.0, 1.0),
    Blue: vec4.fromValues(0.0, 0.0, 1.0, 1.0),
    DarkBlue: vec4.fromValues(0.0, 0.0, 0.5, 1.0),
    Yellow: vec4.fromValues(1.0, 1.0, 0.0, 1.0),
    Orange: vec4.fromValues(1.0, 0.5, 0.0, 1.0),
    DarkGrey: vec4.fromValues(0.25, 0.25, 0.25, 1.0),
    Grey: vec4.fromValues(0.5, 0.5, 0.5, 1.0),
    LightGrey: vec4.fromValues(0.75, 0.75, 0.75, 1.0),
};

export const Vec4Basics = {
    Zero: vec4.fromValues(0.0, 0.0, 0.0, 1.0),
    X: vec4.fromValues(1.0, 0.0, 0.0, 1.0),
    Y: vec4.fromValues(0.0, 1.0, 0.0, 1.0),
    Z: vec4.fromValues(0.0, 0.0, 1.0, 1.0),
};

export const Vec3Basics = {
    Zero: vec3.fromValues(0.0, 0.0, 0.0),
    X: vec3.fromValues(1.0, 0.0, 0.0),
    Y: vec3.fromValues(0.0, 1.0, 0.0),
    Z: vec3.fromValues(0.0, 0.0, 1.0),
};

export const MathConst = {
    fEps: 1.0e-7,
    fEps2: 1.0e-5,
    fPI_HALF: 1.57079632679,
    fPI_QUARTER : 0.78539816339,
    fPI: 3.14159265359,
    fTWO_PI: 6.28318530718,
    fInvPi: 1.0 / 3.14159265359,
    fInvTwoPi: 1.0 / 6.28318530718,
    fSqrt2: Math.sqrt(2.0),
    fSqrt3: Math.sqrt(3.0),
    fE: 2.7182818284,
    fGoldenRatio: 1.6180339887,
    fOneMinusEps: 1.0 - 1.0e-7,
    fDegToRad: 3.14159265359 / 180.0,
    fRadToDeg: 180.0 / 3.14159265359,
};
